<ng-container *ngIf="stage;else dash">
{{stage}}
</ng-container>
<ng-template #dash>-</ng-template>

